import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { APP_NAME } from '../config/branding';
import './Header.css';

const Header: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const isActive = (path: string) => {
        if (path === '/privacy-policy') {
            return location.pathname.startsWith('/privacy-policy');
        }
        if (path === '/terms-of-use') {
            return location.pathname.startsWith('/terms-of-use');
        }

        return location.pathname === path;
    };

    return (
        <header className="header">
            <div className="container">
                <div className="header-content">
                    <Link to="/" className="logo" onClick={closeMenu}>
                        <span className="logo-icon">💰</span>
                        <span className="logo-text">{APP_NAME}</span>
                    </Link>

                    <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
                        <Link
                            to="/"
                            className={`nav-link ${isActive('/') ? 'active' : ''}`}
                            onClick={closeMenu}
                        >
                            Ana Sayfa
                        </Link>
                        <Link
                            to="/help-support"
                            className={`nav-link ${isActive('/help-support') ? 'active' : ''}`}
                            onClick={closeMenu}
                        >
                            Yardım & Destek
                        </Link>
                        <Link
                            to="/privacy-policy"
                            className={`nav-link ${isActive('/privacy-policy') ? 'active' : ''}`}
                            onClick={closeMenu}
                        >
                            Gizlilik Politikası
                        </Link>
                        <Link
                            to="/terms-of-use"
                            className={`nav-link ${isActive('/terms-of-use') ? 'active' : ''}`}
                            onClick={closeMenu}
                        >
                            Kullanım Koşulları
                        </Link>
                        <a
                            href="https://play.google.com/store/apps/details?id=com.saitgumus.budgetmanagement"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary download-btn"
                            onClick={closeMenu}
                        >
                            İndir
                        </a>
                    </nav>

                    <button className="mobile-menu-btn" onClick={toggleMenu}>
                        <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
